import { useQuery } from "@tanstack/react-query";

import { InfoResponse } from "@/@types/growthos-api/schema/openapi";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { QueryConfig } from "@/lib/react-query";
import { axiosApi } from "@/Utils";

export const getInfoNestJs = async (): Promise<InfoResponse> => {
  const response = await axiosApi.get("/api/info", { baseURL: NEST_BACKEND_URL });
  return response as unknown as InfoResponse;
};

export const useNestJsInfo = ({ config }: { config?: QueryConfig<typeof getInfoNestJs> }) => {
  return useQuery({
    ...config,
    queryKey: ["nest-js-info"],
    queryFn: getInfoNestJs,
  });
};
